import apiClient from '../utils/apiClient';

export const inventoryAPI = {
  // --- Materials ---
  getMaterials: async (params = {}) =>
    apiClient.get({ url: '/materials', params }),

  getMaterial: async (id) =>
    apiClient.get({ url: `/materials/${id}` }),

  createMaterial: async (data) =>
    apiClient.post({ url: '/materials', data }),

  updateMaterial: async (id, data) =>
    apiClient.patch({ url: `/materials/${id}`, data }),

  deleteMaterial: async (id) =>
    apiClient.delete({ url: `/materials/${id}` }),

  // --- Suppliers ---
  getSuppliers: async (params = {}) =>
    apiClient.get({ url: '/suppliers', params }),

  createSupplier: async (data) =>
    apiClient.post({ url: '/suppliers', data }),

  updateSupplier: async (id, data) =>
    apiClient.patch({ url: `/suppliers/${id}`, data }),

  // #125114 — ghi vết ai đổi SĐT Zalo, lúc nào, từ số nào sang số nào (AC 26)
  getSupplierZaloPhoneHistory: async (id) =>
    apiClient.get({ url: `/suppliers/${id}/zalo-phone-history` }),

  // --- Branch Stock ---
  getBranchStock: async (branchId, params = {}) =>
    apiClient.get({ url: `/branch-stock/${branchId}`, params }),

  getLowStock: async (branchId) =>
    apiClient.get({ url: `/branch-stock/${branchId}/low-stock` }),

  getTransactions: async (branchId, params = {}) =>
    apiClient.get({ url: `/branch-stock/${branchId}/transactions`, params }),

  importStock: async (data) =>
    apiClient.post({ url: '/branch-stock/import', data }),

  bulkImport: async (data) =>
    apiClient.post({ url: '/branch-stock/import/bulk', data }),

  transferStock: async (data) =>
    apiClient.post({ url: '/branch-stock/transfer', data }),

  // #011206 — kiểm kê khởi tạo: đặt tồn về ĐÚNG số đếm được tại chi nhánh (quản lý kho làm được,
  // không riêng Admin). Khác importStock: đây là số tuyệt đối, không phải số nhập thêm — cách duy
  // nhất đưa NVL đang âm mà chưa từng nhập kho về số thật.
  setBranchActualStock: async (branchId, materialId, actualQuantity, note) =>
    apiClient.patch({
      url: `/branch-stock/${branchId}/actual-quantity/${materialId}`,
      data: { actual_quantity: actualQuantity, note },
    }),

  // #232210 — ngưỡng tối thiểu riêng theo chi nhánh (chỉ Admin). value=null để xoá override.
  setBranchMinStockOverride: async (branchId, materialId, value) =>
    apiClient.patch({
      url: `/branch-stock/${branchId}/min-stock-override/${materialId}`,
      data: { min_stock_override: value },
    }),

  // #151257 — định mức riêng theo chi nhánh (chỉ Admin). value=null để xoá override.
  setBranchParLevelOverride: async (branchId, materialId, value) =>
    apiClient.patch({
      url: `/branch-stock/${branchId}/par-level-override/${materialId}`,
      data: { par_level_override: value },
    }),

  // #155519 — áp mức chung sang mức riêng hàng loạt NVL theo tỷ lệ (chỉ Admin). `body`:
  // { target: 'par_level'|'min_stock'|'both', ratio: number, overwrite_existing?: bool, material_ids?: string[] }
  previewApplyRatio: async (branchId, body) =>
    apiClient.post({ url: `/branch-stock/${branchId}/apply-ratio/preview`, data: body }),

  applyRatio: async (branchId, body) =>
    apiClient.post({ url: `/branch-stock/${branchId}/apply-ratio`, data: body }),

  // --- Recipes ---
  getRecipe: async (menuItemId) =>
    apiClient.get({ url: `/recipes/menu-item/${menuItemId}` }),

  getMenuItemsWithoutRecipe: async () =>
    apiClient.get({ url: '/recipes/menu-items-without-recipe' }),

  getRecipeCoverage: async () =>
    apiClient.get({ url: '/recipes/coverage' }),

  upsertRecipe: async (data) =>
    apiClient.post({ url: '/recipes/upsert', data }),

  deleteRecipe: async (id) =>
    apiClient.delete({ url: `/recipes/${id}` }),

  upsertAdjustment: async (data) =>
    apiClient.post({ url: '/recipes/adjustments', data }),

  deleteAdjustment: async (id) =>
    apiClient.delete({ url: `/recipes/adjustments/${id}` }),

  // --- Stocktake ---
  getStocktakeSessions: async (params = {}) =>
    apiClient.get({ url: '/stocktake/sessions', params }),

  getStocktakeSession: async (sessionId) =>
    apiClient.get({ url: `/stocktake/session/${sessionId}` }),

  cancelStocktakeSession: async (sessionId) =>
    apiClient.patch({ url: `/stocktake/session/${sessionId}/cancel`, data: {} }),

  // --- Reports ---
  getDashboard: async (branchId) =>
    apiClient.get({ url: `/inventory/dashboard/${branchId}` }),

  getConsumptionReport: async (params = {}) =>
    apiClient.get({ url: '/inventory/consumption-report', params }),

  getVarianceReport: async (params = {}) =>
    apiClient.get({ url: '/inventory/variance-report', params }),

  getShrinkageReport: async (params = {}) =>
    apiClient.get({ url: '/inventory/shrinkage-report', params }),

  // --- Material Packages ---
  getMaterialPackages: async (materialId) =>
    apiClient.get({ url: '/material-packages', params: { material_id: materialId } }),

  createMaterialPackage: async (data) =>
    apiClient.post({ url: '/material-packages', data }),

  updateMaterialPackage: async (id, data) =>
    apiClient.patch({ url: `/material-packages/${id}`, data }),

  deleteMaterialPackage: async (id) =>
    apiClient.delete({ url: `/material-packages/${id}` }),

  // --- Import Requests ---
  getImportRequests: async (params = {}) =>
    apiClient.get({ url: '/import-requests', params }),

  getImportRequest: async (id) =>
    apiClient.get({ url: `/import-requests/${id}` }),

  approveImportRequest: async (id, userId) =>
    apiClient.post({ url: `/import-requests/${id}/approve`, data: { current_user_id: userId } }),

  rejectImportRequest: async (id, userId, reason) =>
    apiClient.post({ url: `/import-requests/${id}/reject`, data: { current_user_id: userId, reason } }),

  // --- BTP Recipe (Công thức bán thành phẩm) ---
  getBtpRecipe: async (materialId) =>
    apiClient.get({ url: `/materials/${materialId}/btp-recipe` }),

  upsertBtpRecipe: async (materialId, items, yieldQuantity) =>
    apiClient.post({ url: `/materials/${materialId}/btp-recipe`, data: { items, yield_quantity: yieldQuantity ?? undefined } }),

  deleteBtpIngredient: async (materialId, ingredientId) =>
    apiClient.delete({ url: `/materials/${materialId}/btp-recipe/${ingredientId}` }),

  // --- Production (Sản xuất BTP) ---
  previewProduction: async (materialId, quantity, branchId) =>
    apiClient.get({ url: '/inventory/production/preview', params: { semi_finished_material_id: materialId, quantity, branch_id: branchId } }),

  createProduction: async (data) =>
    apiClient.post({ url: '/inventory/production', data }),

  getProductionLogs: async (params = {}) =>
    apiClient.get({ url: '/inventory/production', params }),

  // --- Shift Material Check (ON-39) ---
  getShiftCheckFlags: async (branchId) =>
    apiClient.get({ url: `/branch-stock/${branchId}/shift-check-flags` }),

  setShiftCheckFlag: async (branchId, materialId, data) =>
    apiClient.patch({ url: `/branch-stock/${branchId}/shift-check/${materialId}`, data }),

  getShiftMaterialChecks: async (params = {}) =>
    apiClient.get({ url: '/inventory/shift-material-checks', params }),
};
